"use client"

import { pageDropAtom } from "@/app/[blockchain]/collections/[id]/drops/page-drop.reatom"
import {
  ItemDetailsSkeleton,
  ItemDetailsView,
} from "@/app/item/view/item-details-view"
import { ItemCollapsibleInfoCard } from "@/app/item/view/item-info-card"
import { getBlockchainLabel } from "@/app/nft/details/views/blockchain"
import { CollectionAddress } from "@/app/nft/details/views/collection-address"
import { Trans } from "@lingui/react/macro"
import { reatomComponent } from "@reatom/react"
import { Suspense } from "react"
import { ErrorBoundary } from "react-error-boundary"

export function DropDetailsView() {
  return (
    <ItemCollapsibleInfoCard
      header={<Trans>Details</Trans>}
      content={
        <ErrorBoundary fallback={null}>
          <Suspense fallback={<ItemDetailsSkeleton count={4} />}>
            <DropDetailsContent />
          </Suspense>
        </ErrorBoundary>
      }
    />
  )
}

export const DropDetailsContent = reatomComponent(() => {
  const drop = pageDropAtom()

  if (!drop) {
    return <ItemDetailsSkeleton count={4} />
  }

  const detailsData = [
    {
      title: <Trans>Contract Address</Trans>,
      description: <CollectionAddress address={drop.id} />,
    },
    {
      title: <Trans>Token Standard</Trans>,
      description: drop.tokenStandard,
    },
    ...(drop.author
      ? [
          {
            title: <Trans>Owner</Trans>,
            description: <span>{drop.author}</span>,
          },
        ]
      : []),
    {
      title: <Trans>Chain</Trans>,
      description: getBlockchainLabel(drop.blockchain),
    },
  ]

  return <ItemDetailsView detailsData={detailsData} />
}, "DropDetailsContent")

export function DropDetails() {
  return <DropDetailsView />
}
